import { render, staticRenderFns } from "./user-token.vue?vue&type=template&id=194831b6&scoped=true"
import script from "./user-token.vue?vue&type=script&lang=js"
export * from "./user-token.vue?vue&type=script&lang=js"
import style0 from "./user-token.vue?vue&type=style&index=0&id=194831b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194831b6",
  null
  
)

export default component.exports